import { render, staticRenderFns } from "./AttributeDelete.vue?vue&type=template&id=2bbb1a6e&scoped=true"
import script from "./AttributeDelete.vue?vue&type=script&lang=js"
export * from "./AttributeDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb1a6e",
  null
  
)

export default component.exports